var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "404-page page-error" },
    [
      _c("EmptyState", {
        attrs: {
          "confirm-action": _vm.redirect,
          illustration: "404",
          title: "Ops! A página que você procura não foi encontrada!",
          subtitle:
            "A página que você tentou acessar não existe mais. Mas não se preocupe, para continuar navegando você pode voltar para o início e fazer um outro caminho dentro da plataforma.",
          "confirm-action-text": "Voltar para o início",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }